import React from 'react';

const FreelanceHome = () => {
  return (
    <div>
      <h1>Freelance Inicio</h1>
      {/* Add your content here */}
    </div>
  );
};

export default FreelanceHome;
